module.exports = __webpack_public_path__ + "static/media/flight.9ac22a94.jpg";